var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "LoadingOverlay",
    { attrs: { loading: !_vm.dataLoaded, hasData: _vm.dataLoaded } },
    [
      _vm.dataLoaded
        ? _c("router-view", {
            attrs: {
              company: _vm.company,
              currentUser: _vm.currentUser,
              authenticated: _vm.authenticated,
            },
            on: {
              refetch: function ($event) {
                return _vm.$emit("refetch")
              },
              signOut: function ($event) {
                return _vm.$emit("signOut")
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }